import { Howl, Howler } from 'howler';

const homeSound = new Howl({
    src: ['./assets/sounds/components/island/home.webm', './assets/sounds/components/island/home.mp3'],
    volume: 0.2,
    loop: true
});

const openSound = new Howl({
    src: ['./assets/sounds/components/island/insight.webm', './assets/sounds/components/island/insight.mp3'],
});

const closeSound = new Howl({
    src: ['./assets/sounds/components/island/just-like-magic.webm', './assets/sounds/components/island/just-like-magic.mp3'],
});

const bgSound = new Howl({
    src: ['./assets/sounds/components/island/tropical.wav', './assets/sounds/components/island/tropical.mp3'],
    volume: 0.2,
    loop: true
});

const eatingSound = new Howl({
    src: ['./assets/sounds/components/island/eating.mp3'],
    loop: true
});

const speakingSound = new Howl({
    src: ['./assets/sounds/components/island/dinospeak.mp3'],
});

const trashSound = new Howl({
    src: ['./assets/sounds/components/island/trash_sound.mp3'],
    volume: 0.6,
});

export const HowlerUtils = (() => {
    const muteGlobalVolume = () => Howler.mute(true);
    const unMuteGlobalVolume = () => Howler.mute(false);;

    const stopSound = (soundId) => {
        switch (soundId) {
            case 'home':
                homeSound.stop();
                break;
            case 'open':
                openSound.stop();
                break;
            case 'close':
                closeSound.stop();
                break;
            case 'jungle':
                bgSound.stop();
                break;
            case 'eating':
                eatingSound.stop();
                break;
            case 'speaking':
                speakingSound.stop();
                break;
            case 'trash':
                trashSound.stop();
                break;
            default:
        }
    }

    const playSound = (soundId) => {
        switch (soundId) {
            case 'home':
                homeSound.play();
                break;
            case 'open':
                openSound.play();
                break;
            case 'close':
                closeSound.play();
                break;
            case 'jungle':
                bgSound.play();
                break;
            case 'eating':
                eatingSound.play();
                break;
            case 'speaking':
                speakingSound.play();
                break;
            case 'trash':
                trashSound.play();
                break;
        }
    }

    return {
        muteGlobalVolume: muteGlobalVolume,
        unMuteGlobalVolume: unMuteGlobalVolume,
        stopSound: stopSound,
        playSound: playSound,
    }

})();